import Form from "./Form";
import usePolicyholderMembershipLevel from "./hooks/usePolicyholderMembershipLevel";
import { IndexProps } from "./types";

export const PolicyholderMembershipLevel: React.FC<IndexProps> = ({ policyholderType }) => {
  const props = usePolicyholderMembershipLevel(policyholderType);
  return <Form {...props} />;
};
export default PolicyholderMembershipLevel;
